module.exports = __webpack_public_path__ + "static/016-slideshow-98ffb9cc56f3a31eedaa4cd061db08c0.jpg";